var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityRampedSlopedAccessAndOrManualDoors = function SvgAccessibilityRampedSlopedAccessAndOrManualDoors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m21.086 21.079 7.061 1.518a.76.76 0 0 0 .95-.759V4.908a.82.82 0 0 0-.95-.798l-7.06 1.519a.805.805 0 0 0-.646.759V20.32a.76.76 0 0 0 .645.759M.777 23.888 8.94 25.9m-.001 0 20.157-.76m.127-.037v-3.227"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 10.913,
    cy: 10.26,
    r: 1.518
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M11.748 13.133c-.567.37-1.201.325-1.746-.126m-.228 4.579a4 4 0 0 1 .949-.303A3.568 3.568 0 1 1 8.331 18.8"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10.002 12.917a7.3 7.3 0 0 0-1.67 2.81 3.73 3.73 0 0 0 .38 3.226c.17.31.388.591.644.835.158.247.382.444.646.57a.642.642 0 0 0 .797-.76c-.076-.417-.418-.683-.645-1.025a4 4 0 0 1-.532-1.062 1.59 1.59 0 0 1 .228-1.48l.531 1.29m4.024 1.708.911-.152c.038.076 1.48 2.657 1.633 3 .152.227.265.53.531.644a.63.63 0 0 0 .456.038.706.706 0 0 0 .455-.949c-.607-1.48-1.253-2.923-1.86-4.403a.34.34 0 0 0-.304-.19c-.949 0-1.822 0-2.77-.038l-1.671-3.948M8.939 25.9l19.93-3.113M.777 23.888l7.554-1.1m6.529-.646 1.975-.506m1.632-.14 2.24-.506"
  }))));
};
export default SvgAccessibilityRampedSlopedAccessAndOrManualDoors;